import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBGHCgyF3bSKW7bBTPEwZbksxYLRkGnuTk",
  authDomain: "anchor-finex.firebaseapp.com",
  projectId: "anchor-finex",
  storageBucket: "anchor-finex.firebasestorage.app",
  messagingSenderId: "678056199894",
  appId: "1:678056199894:web:78bc9e380c78372f932b77",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
